import * as styles from './styles.css';
import clsx from 'clsx';
import { Responsive, TDeviceType } from '@cian/ui-kit/responsive';
import { Carousel } from 'shared/components/Carousel';
import { useCarousel } from 'shared/hooks';
import { TBanner } from 'shared/types/carousel';
import { shouldShowCarouselArrows } from 'shared/utils/carousel';
import { renderBanner } from 'shared/utils/banners';
import { NBSP } from 'shared/constants/symbols';

interface IStepProps {
  id: string | number;
  step: number;
  title: string;
  slides: React.ReactNode;
  slidesCount: number;
  device: TDeviceType;
  isFirst?: boolean;
  banner?: TBanner;
}

export const Step: React.FC<IStepProps> = ({ step, title, slides, slidesCount, device, banner, isFirst = false }) => {
  const { emblaRef, scrollPrev, scrollNext, canScrollPrev, canScrollNext } = useCarousel(device, slidesCount);
  const showArrows = shouldShowCarouselArrows(slidesCount, device);

  return (
    <div className={clsx(styles['container'], isFirst && styles['first'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['content']}>
          {isFirst && <h2 className={styles['main-title']}>7 шагов к эффективному размещению на{NBSP}Циан</h2>}
          <div className={styles['nav-container']}>
            <Responsive desktop tablet>
              <div className={styles['step']}>{step}</div>
            </Responsive>
            <Responsive phone>
              <div className={styles['step-text']}>Шаг {step}</div>
            </Responsive>
            <h3 className={styles['title']}>{title}</h3>
            {showArrows && (
              <div className={styles['arrows']}>
                <button
                  type="button"
                  className={clsx(styles['arrow'], styles['arrow-prev'])}
                  onClick={scrollPrev}
                  disabled={!canScrollPrev}
                  aria-label="Предыдущая статья"
                />
                <button
                  type="button"
                  className={clsx(styles['arrow'], styles['arrow-next'])}
                  onClick={scrollNext}
                  disabled={!canScrollNext}
                  aria-label="Следующая статья"
                />
              </div>
            )}
          </div>
          <Carousel emblaRef={emblaRef}>{slides}</Carousel>
          {banner && <div className={styles['banner']}>{renderBanner(banner)}</div>}
        </div>
      </div>
    </div>
  );
};
